import { useState, useEffect, type FormEvent } from 'react';
import { useAuthStore } from '../stores/authStore';

const SAVED_EMAIL_KEY = 'admin_saved_email';
const REMEMBER_EMAIL_KEY = 'admin_remember_email';

export default function LoginPage() {
  const { login, error, loading } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberEmail, setRememberEmail] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(REMEMBER_EMAIL_KEY) === 'true';
    setRememberEmail(saved);
    if (saved) {
      const savedEmail = localStorage.getItem(SAVED_EMAIL_KEY) || '';
      setEmail(savedEmail);
    }
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (rememberEmail) {
      localStorage.setItem(SAVED_EMAIL_KEY, email);
      localStorage.setItem(REMEMBER_EMAIL_KEY, 'true');
    } else {
      localStorage.removeItem(SAVED_EMAIL_KEY);
      localStorage.setItem(REMEMBER_EMAIL_KEY, 'false');
    }
    try { await login(email, password); } catch { /* error shown via store */ }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 rounded-xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white">OurHertz Admin</h1>
          <p className="text-gray-400 mt-2">관리자 로그인</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-1">이메일</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="admin@ourhertz.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm text-gray-400 mb-1">비밀번호</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-blue-500 focus:outline-none"
              placeholder="********"
              required
            />
          </div>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={rememberEmail}
              onChange={e => setRememberEmail(e.target.checked)}
              className="rounded"
            />
            <span className="text-sm text-gray-400">이메일 저장</span>
          </label>

          {error && <p className="text-red-400 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-semibold rounded-lg transition"
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <p className="text-center text-gray-600 text-xs mt-6">v{__APP_VERSION__}</p>
      </div>
    </div>
  );
}
